import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SearchHistoryItem {
  query: string;
  timestamp: number;
  type?: 'hash' | 'group' | 'ioc' | 'vulnerability';
}

interface SearchHistoryState {
  searches: SearchHistoryItem[];
  addSearch: (query: string, type?: 'hash' | 'group' | 'ioc' | 'vulnerability') => void;
  clearHistory: () => void;
}

export const useSearchHistory = create<SearchHistoryState>()(
  persist(
    (set) => ({
      searches: [],
      addSearch: (query: string, type?: 'hash' | 'group' | 'ioc' | 'vulnerability') => 
        set((state) => {
          // Remove duplicates and keep only the most recent 10 searches
          const filteredSearches = state.searches
            .filter(item => item.query !== query)
            .slice(0, 9);
          
          return {
            searches: [
              { query, timestamp: Date.now(), type },
              ...filteredSearches,
            ],
          };
        }),
      clearHistory: () => set({ searches: [] }),
    }),
    {
      name: 'search-history',
    }
  )
);